module.exports = __webpack_public_path__ + "img/Flag_of_Jordan.34d7eca8.svg";